const versionNumber = "2.0.9";

export default versionNumber;
